import { joinClasses } from 'utils/componentStyles/style.utils';

const WeatherMapListButton = ({ children, isSelected = false, ariaLabel, className, onClick }) => (
  <button
    type="button"
    aria-current={isSelected ? 'true' : undefined}
    aria-label={ariaLabel}
    className={joinClasses(
      'weather-map-list-button d-flex w-100 border-0 border-bottom text-start',
      className,
    )}
    onClick={onClick}
  >
    {children}
  </button>
);

export default WeatherMapListButton;
